import React from "react";
import { Container } from "@mui/material";

function Team() {
  return (
    <main className="team-page">
      <h1 className="team-page__title">About Sowmya</h1>
      <Container maxWidth="md">
        <div className="team-page__bio">
          <p>
            <strong>Sowmya Kadaveru</strong> is a Yoga and SKY Breath Meditation
            teacher for all ages. She has practiced yoga and meditation since
            2011 and is a speech-language pathologist in London, Ontario. She
            is a 500-hour certified yoga instructor, with additional training
            in prenatal and children’s yoga. Since 2015, she has taught
            programs that have positively impacted youth and the wider
            community.
          </p>
        </div>
      </Container>
    </main>
  );
}

export default Team;
